<template>
    <v-tab-item :value="tabValue" class="fill-height">
        <v-layout column justify-center align-center fill-height style="overflow-y: hidden">
            <v-card-subtitle>
                <v-chip>{{ meeting?.title }}</v-chip>
            </v-card-subtitle>
            <v-card-title>매칭가능 기간이 아닙니다.</v-card-title>
            <v-card-subtitle class="text-center"> 매칭가능 일정을 확인해주세요. </v-card-subtitle>
            <v-card-actions class="justify-center">
                <slot name="tab-complete-actions" />
            </v-card-actions>
        </v-layout>
    </v-tab-item>
</template>

<script>
import { initMeeting } from "@/assets/variables";

export default {
    props: {
        meeting: { type: Object, default: initMeeting },
        tabValue: { type: String },
    },
};
</script>

<style>
</style>